'use server';
import './App.css';
import NavBar from './components/general/NavBar';
import Footer from './views/Footer';
import Branches from './pages/Branches';
import { ProductContext } from './contexts/GeneralContexts';
import { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Theme, ThemeProvider } from '@mui/material/styles';
import { CircularProgress, Toolbar } from '@mui/material';
import ComponentRender from './pages/ComponentRender';
import DetailBlog from './pages/Blog/DetailBlog';
import ComiteRemuneracion from './pages/footer/ComiteRemuneracion';
import CostosComisiones from './pages/footer/CostosComisiones';
import DespachoCobranza from './pages/footer/DespachoCobranza';
import NewBuro from './pages/footer/NewBuro';
import TerminosConticiones from './pages/footer/TerminosConticiones';
import AvisoDePrivacidad from './pages/footer/AvisoDePrivacidad';
import AgreementForm from "./pages/Agreements/AgreementForm";
import MainPage from './components/pages/MainPage';
import { getPathsProducts, getPathsProductTypes } from './services/ContentServices';
import { pathsProducts } from './types/ContentStructure';
import { slugify } from './utils/utils';
import ProductTypePage from './pages/ProductType/ProductTypePage';
import ProductPage from './pages/Product/ProductPage';
import Notification from './components/general/CookieNotification';
import theme from './themes/theme';

const Une = lazy(() => import('./pages/Une'));
const ProtectionFund = lazy(() => import('./pages/ProtectionFund'));
const FinancialReports = lazy(() => import('./pages/FinancialReports'));
const LegalNotice = lazy(() => import('./pages/AvisoLegal'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Blog = lazy(() => import(`./pages/Blog/Blog`));

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme { }
}

function App() {

  const [contextProd, setContexProd] = useState({});
  const [pathsProducts, setPathsProducts] = useState([]);
  const [pathsProductTypes, setPathsProductTypes] = useState([]);
  const [routesLoaded, setRoutesLoaded] = useState(false);

  useEffect(() => {
    const loadRoutes = async () => {
      const products = await getPathsProducts();
      const productTypes = await getPathsProductTypes();
      setPathsProducts(products.data);
      setPathsProductTypes(productTypes.data);
      setRoutesLoaded(true);
    };
    loadRoutes();
  }, []);

  if (!routesLoaded) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <BrowserRouter>
          <Notification />
          <NavBar />
          <Toolbar />
          <ProductContext.Provider value={[contextProd, setContexProd]} >
            <Suspense fallback={
              <CircularProgress
                color="error"
                size="lg"
                value={55}
                sx={{ m: 30 }}
              />
            }>
              <Routes>
                <Route path='/sucursales' element={<Branches />} />
                <Route path='/nosotros' element={<AboutUs />} />
                <Route path='/une/' element={<Une />} />
                <Route path='/fondo-de-proteccion/' element={<ProtectionFund />} />
                <Route path='/reportes-financieros/' element={<FinancialReports />} />
                <Route path='/aviso-legal/' element={<LegalNotice />} />
                <Route path="/documentacion" element={<ComponentRender />} />
                <Route path='/blog/' element={<Blog />} />
                <Route path="/blog/:formattedTitulo/:id/" element={<DetailBlog />} />
                <Route path="/convenio/:agreement/:agreementId/" element={<AgreementForm />} />
                <Route path='/comite-remuneracion/' element={<ComiteRemuneracion />} />
                <Route path='/terminos-condiciones/' element={<TerminosConticiones />} />
                <Route path='/costos-comisiones/' element={<CostosComisiones />} />
                <Route path='/aviso-privacidad/' element={<AvisoDePrivacidad />} />
                <Route path='/despacho-cobranza/' element={<DespachoCobranza />} />
                <Route path='/new-buro/' element={<NewBuro />} />
                <Route path="/" element={<MainPage />} />

                {pathsProducts && pathsProducts.map((product: pathsProducts, index) => {
                  const route = `/${slugify(product.productTypeName)}/${slugify(product.name)}`;
                  console.log("Route Products: ", route);
                  return (
                    <Route key={index} path={route} element={<ProductPage product_name={product.name} />} />
                  );
                })}
                {pathsProductTypes && pathsProductTypes.map((productType: any, index) => {
                  const route = `/${slugify(productType.name)}`;
                  console.log("Route Product Types: ", route);
                  return (
                    <Route key={index} path={route} element={<ProductTypePage product_type={productType.name} />} />
                  );
                })}

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
            <Footer />
          </ProductContext.Provider>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
